export const SUPPORTED_LOCALES = ['en-US', 'he-IL'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'he-IL';

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function localeToLanguageTag(locale: string): 'en' | 'he' {
  if (locale.startsWith('he')) return 'he';
  return 'en';
}

export function languageTagToLocale(tag: 'en' | 'he'): SupportedLocale {
  return tag === 'he' ? 'he-IL' : 'en-US';
}

const RTL_LANGUAGE_TAGS = new Set(['he', 'ar', 'fa', 'ur']);

export function isRTL(localeOrTag: string): boolean {
  const tag = localeOrTag.split('-')[0] ?? '';
  return RTL_LANGUAGE_TAGS.has(tag);
}

export function getDirection(localeOrTag: string): 'ltr' | 'rtl' {
  return isRTL(localeOrTag) ? 'rtl' : 'ltr';
}

export const LOCALE_NAMES: Record<SupportedLocale, string> = {
  'en-US': 'English',
  'he-IL': 'עברית',
};
